import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.section`
  background-color: #ededed;
  padding: 0 0 40px 0;
  position: relative;
  z-index: 1;
  clear: both;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const Title = styled.h2`
  color: #212121;
  font-size: 45px;
  font-family: 'Geologica', Arial, sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 20px;
  
  strong {
    color: #3c57d2;
    font-weight: inherit;
  }
  
  @media (max-width: 479px) {
    font-size: 24px;
  }
`;

const Subtitle = styled.p`
  color: #212121;
  font-size: 24px;
  font-family: 'Geologica', Arial, sans-serif;
  
  @media (max-width: 479px) {
    font-size: 16px;
  }
`;

const AccordionWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

const AccordionItem = styled.div`
  background-color: white;
  border-radius: 10px;
  margin-bottom: 2px;
  overflow: hidden;
`;

const AccordionHeader = styled.button`
  width: 100%;
  padding: 20px;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  text-align: left;
  font-family: 'Geologica', Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #212121;
  
  &:hover {
    background-color: #f8f8f8;
  }
  
  @media (max-width: 479px) {
    padding: 15px;
    font-size: 16px;
  }
`;

const AccordionContent = styled.div`
  padding: ${({ $isOpen }) => ($isOpen ? '0 20px 20px 20px' : '0 20px')};
  max-height: ${({ $isOpen }) => ($isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: all 0.3s ease;
  color: #212121;
  font-size: 16px;
  line-height: 1.5;
  
  @media (max-width: 479px) {
    font-size: 14px;
    padding: ${({ $isOpen }) => ($isOpen ? '0 15px 15px 15px' : '0 15px')};
  }
`;

const Icon = styled.span`
  width: 24px;
  height: 24px;
  position: relative;
  flex-shrink: 0;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    background-color: #222;
    transition: transform 0.3s ease;
  }
  
  &::before {
    width: 2px;
    height: 16px;
    top: 4px;
    left: 11px;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(90deg)' : 'rotate(0)')};
  }
  
  &::after {
    width: 16px;
    height: 2px;
    top: 11px;
    left: 4px;
  }
`;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: 'Кто встретит в аэропорту?',
      answer: 'Наш водитель или представитель компании будет ждать вас с табличкой прямо в зоне прилёта. Никаких поисков и стрессов — вас встретят, помогут с багажом и довезут до отеля. Если рейс задержится, мы всё равно будем на месте: мы отслеживаем прилёты онлайн.'
    },
    {
      question: 'Что делать, если изменятся даты?',
      answer: 'Мы всегда на связи 24/7. Если планы поменялись — менеджер подберёт новые даты и варианты без лишней головной боли. Все изменения фиксируются в договоре, поэтому никаких «сюрпризов» по цене не будет.'
    },
    {
      question: 'Можно ли оформить дистанционно?',
      answer: 'Да, конечно. Все документы можно подписать онлайн, оплату провести удобным способом, а готовые ваучеры и билеты вы получите на почту или в мессенджер. Если хотите — можно и в офисе, но большинство клиентов выбирают дистанционный формат.'
    },
    {
      question: 'Какие гарантии?',
      answer: 'Работаем официально с 2014 года, есть регистрационный номер и договор. Более 10 000 довольных клиентов и 125 отзывов на 2ГИС. Сотрудничаем только с крупными туроператорами, фиксируем смету и не навязываем допуслуги. 30% клиентов возвращаются к нам снова — это лучшая гарантия качества.'
    }
  ];

  return (
    <Container>
      <Content>
        <Header>
          <Title>
            <strong>Ответы на часто</strong> задаваемые вопросы
          </Title>
          <Subtitle>Нажмите по вопросу, чтобы получить на него ответ</Subtitle>
        </Header>
        
        <AccordionWrapper>
          {faqItems.map((item, index) => (
            <AccordionItem key={index}>
              <AccordionHeader onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                {item.question}
                <Icon $isOpen={openIndex === index} />
              </AccordionHeader>
              <AccordionContent $isOpen={openIndex === index}>
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </AccordionWrapper>
      </Content>
    </Container>
  );
};

export default FAQ;